export default {
    'revista-coamo': 'coamo',
    'revista-coamo-kids': 'kids',
    'revista-somos-coamo': 'somoscoamo',
}